import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Main pages
import HomePage from "./HomePage";
import CloudServicesPage from "./components/Cloud-Services/CloudServicesPage";
import ArvrServicesParentpage from "./components/Ar-vrServicespage/ArvrServicesParentpage";
import IOTServices from "./components/IOT-Services-Page/IOTServices";
import CustomSoftware from "./components/CustomSoftwarepage/CustomSoftware";
import AIandMLpage from "./components/AIandML/AIandMLpage";
import DataManagement from "./components/DataManagementPage/DataManagement";
import ContactUs from "./components/ContactUs/contactUs";

// Shared layout components
import Header from "./components/header/header";
import Footer from "./components/Footer/Footer";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";

// Second layout components
import SinglePageLayout from "./components/header/header2.tsx/SinglePageLayout";
import Header2 from "./components/header/header2.tsx/headersecondpage";
import Footer2 from "./components/Footer/secondFooter/Footer2";

import "./App.css";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
      <Routes>
        {/* ✅ Default layout with Header & Footer */}
        <Route
          path="/*"
          element={
            <>
              <Header />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/cloud-services" element={<CloudServicesPage />} />
                <Route path="/ar/vr-services" element={<ArvrServicesParentpage />} />
                <Route path="/IOT-services" element={<IOTServices />} />
                <Route path="/Custom-Software" element={<CustomSoftware />} />
                <Route path="/AI-ML-Solution" element={<AIandMLpage />} />
                <Route path="/Data-Management" element={<DataManagement />} />
                <Route path="/Contact-Us" element={<ContactUs />} />
              </Routes>
              <Footer />
            </>
          }
        />

        {/* ✅ Separate layout with Header2 & Footer2 */}
        <Route
          path="/Privacy-Policy"
          element={
            <>
              <Header2 />
              <SinglePageLayout />
              <Footer2 />
            </>
          }
        />
      </Routes>
      </div>
    </Router>
  );
}

export default App;
